// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"69ddce13","977":"74c393a6"}[chunkId] + ".chunk.js";
};